const LOGO = "https://static.readdy.ai/image/c4cc08b99909642a7f7632376a1bb059/bdbf4a9d48d2468543b4df36d235abc8.png";

const footerLinks: Record<string, { label: string; href: string }[]> = {
  Serviços: [
    { label: 'CFTV & Monitoramento', href: '#services' },
    { label: 'Controle de Acesso', href: '#services' },
    { label: 'Sistema de Alarme', href: '#services' },
    { label: 'Redes & Infraestrutura', href: '#services' },
  ],
  Empresa: [
    { label: 'Sobre Nós', href: '#about' },
    { label: 'Nossos Clientes', href: '#clients' },
    { label: 'Parceiros', href: '#partners' },
    { label: 'Fale Conosco', href: '#contact' },
  ],
  Suporte: [
    { label: 'Manutenção Preventiva', href: 'https://reconecta.auvo.com.br/Login#signin' },
    { label: 'Suporte Técnico 24/7', href: 'https://reconecta.auvo.com.br/Login#signin' },
    { label: 'Abrir Chamado', href: 'https://reconecta.auvo.com.br/Login#signin' },
    { label: 'Solicitar Orçamento', href: 'https://reconecta.auvo.com.br/Login#signin' },
  ],
};

const socialIcons = [
  { icon: 'ri-linkedin-line', label: 'LinkedIn', href: '#' },
  { icon: 'ri-instagram-line', label: 'Instagram', href: 'https://www.instagram.com/re_conectatecnologia?igsh=ejY5cjQzc3oxeTBs&utm_source=qr' },
  { icon: 'ri-facebook-line', label: 'Facebook', href: '#' },
  { icon: 'ri-whatsapp-line', label: 'WhatsApp', href: '#' },
];

export default function Footer() {
  const handleScrollTo = (href: string) => {
    const target = document.querySelector(href);
    if (target) target.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-neutral-900 border-t border-neutral-800">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid lg:grid-cols-4 gap-12 mb-14">
          {/* Brand Column */}
          <div className="lg:col-span-1">
            <div className="w-40 h-11 flex items-center mb-5">
              <img src={LOGO} alt="RE_CONECTA" className="h-full w-full object-contain brightness-0 invert" />
            </div>
            <p className="text-neutral-400 text-sm leading-relaxed mb-6">
              Tecnologia que conecta segurança e eficiência para empresas de todo o Brasil. Rigor técnico
              e agilidade em cada projeto.
            </p>
            <div className="flex gap-2.5">
              {socialIcons.map(({ icon, label, href }) => (
                <a
                  key={icon}
                  href={href}
                  target={href !== '#' ? '_blank' : undefined}
                  rel={href !== '#' ? 'noopener noreferrer' : undefined}
                  aria-label={label}
                  className="w-9 h-9 flex items-center justify-center border border-neutral-700 rounded-lg hover:border-red-700 hover:text-red-500 text-neutral-500 transition-all cursor-pointer"
                >
                  <i className={`${icon} text-sm`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Link Columns */}
          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="text-white font-semibold text-sm mb-5 uppercase tracking-wide">{title}</h4>
              <ul className="space-y-3">
                {links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      target={link.href.startsWith('http') ? '_blank' : undefined}
                      rel={link.href.startsWith('http') ? 'noopener noreferrer' : 'nofollow'}
                      onClick={!link.href.startsWith('http') ? (e) => { e.preventDefault(); handleScrollTo(link.href); } : undefined}
                      className="text-neutral-500 hover:text-neutral-300 text-sm transition-colors cursor-pointer"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* CTA Strip */}
        <div className="bg-red-600 rounded-2xl p-8 flex flex-col md:flex-row items-center justify-between gap-6 mb-14">
          <div>
            <p className="text-white font-bold text-xl" style={{ fontFamily: 'Poppins, sans-serif' }}>
              Proteja sua empresa agora
            </p>
            <p className="text-red-100 text-sm mt-1">Entre em contato e solicite uma avaliação gratuita</p>
          </div>
          <button
            onClick={() => handleScrollTo('#contact')}
            className="bg-white hover:bg-red-50 text-red-600 px-8 py-3.5 rounded-lg font-semibold text-sm flex items-center gap-2 transition-colors cursor-pointer whitespace-nowrap flex-shrink-0"
          >
            Solicitar Avaliação Gratuita
            <i className="ri-arrow-right-line"></i>
          </button>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-neutral-800 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-neutral-600 text-sm">
            © 2025 RE_CONECTA Tecnologia em Segurança Eletrônica. Todos os direitos reservados.
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-neutral-600 hover:text-neutral-400 text-xs transition-colors cursor-pointer" rel="nofollow">
              Política de Privacidade
            </a>
            <a href="#" className="text-neutral-600 hover:text-neutral-400 text-xs transition-colors cursor-pointer" rel="nofollow">
              Termos de Uso
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
